import $ from "jquery";
import * as GC from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";

export default function standart() {}

export async function fillDetail() {
  $("#d-algemeen-naam").html(
    window.$catalog_work_orders_selectedRow.algemeenNaam
  );
  $("#d-algemeen-naam-tooltip").html(
    window.$catalog_work_orders_selectedRow.algemeenNaam
  );
  $("#d-algemeen-code").html(
    window.$catalog_work_orders_selectedRow.algemeenCode
  );
  $("#d-algemeen-omschrijving").html(
    window.$catalog_work_orders_selectedRow.omschrijving
  );
  $("#d-algemeen-omschrijving-tooltip").html(
    window.$catalog_work_orders_selectedRow.omschrijving
  );
  $("#d-algemeen-status").html(window.$catalog_work_orders_selectedRow.status);
  $("#d-algemeen-compleet").html(
    window.$catalog_work_orders_selectedRow.compleet
  );
  if (window.$catalog_work_orders_selectedRow.compleet)
    $("#algemeen-compleet").attr("checked", "checked");
  else $("#algemeen-compleet").removeAttr("checked");

  if (window.$catalog_work_orders_selectedRow.isActive)
    $("#algemeen_active").attr("checked", "checked");
  else $("#algemeen_active").removeAttr("checked");

  
  //editSide
  $("#e-workorder-naam").val(
    window.$catalog_work_orders_selectedRow.algemeenNaam
  );
  $("#e-workorder-code").val(
    window.$catalog_work_orders_selectedRow.algemeenCode
  );
  $("#e-workorder-omschrijving").val(
    window.$catalog_work_orders_selectedRow.omschrijving
  );

  // $("#e-algemeen-status-select").val(
  //   window.$catalog_work_orders_selectedRow.status
  // );
  // var status = $("#e-algemeen-status");
  // status[0].childNodes.forEach((element) => {
  //   element.textContent == window.$catalog_work_orders_selectedRow.status
  //     ? (element.className = "popuptext-dropdown-a-selected")
  //     : (element.className = "popuptext-dropdown-a");
  // });


  if (window.$catalog_work_orders_selectedRow.isActive)
    $("#e-workorder-active").attr("checked", "checked");
  else $("#e-workorder-active").removeAttr("checked");

  $("#e-identification").val(
    window.$catalog_work_orders_selectedRow.identification
  );
}

export function GetColumnProperties(callType) {
  omnimap
    .GetColumnPropertiesAction(window.$catalog_management_units_token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesCallBack(result, callType);
      // fillDetail();
    });
}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {
  omnimap
    .OmnimapPost(model, pageNr, pageSize, token)
    .then((result) => {
      CallBackFunctions.GetColumnPropertiesForModelCallBack(
        result,
        itemId,
        callType
      );
    })
    .catch((error) => {
      console.log(error);
    });
}

export const rowsHandleDelete = () => {
  // 1. bu kayıtın relationlarını getir.
  // 2. tüm relationlarını sil.
  // 3. sonra kayıtı sil.
  $("#cover-spin").show(0);
  window.$catalog_work_orders_selectedIds.forEach(async (element) => {
    let realtions = await omnimap.GetRelationAction(
      element,
      1,
      30,
      window.$catalog_management_units_token
    );

    if (realtions.data !== undefined) {
      await realtions.data.forEach(async (relation) => {
        let result = await omnimap
          .DeleteRelationAction(
            relation.identification,
            window.$catalog_management_units_token
          )
          .catch((error) => {
            console.log(error);
          });
        var test = "";
      });
    }

    GC.sleep(2000).then(async () => {
      let result = await omnimap
        .Delete(element, window.$catalog_management_units_token)
        .catch((error) => {
          console.log(error);
        });

      CallBackFunctions.RowsDeletedCallBack(
        window.$catalog_management_units_token
      );
    });
  });
};
